import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-work-location-edit',
  standalone: false,
  templateUrl: './work-location-edit.component.html',
  styleUrl: './work-location-edit.component.scss',
})
export class WorkLocationEditComponent implements OnInit {
  workLocationId: number;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.workLocationId = this.route.snapshot.params['id'];
  }
}
